import React, { useEffect, useState } from "react";
import {
  DownloadApprovedClientsAPICall,
  DownloadPendingClientsAPICall,
  getApprovedClientDetailsAPICall,
  getClientDetailsAPICall,
} from "../../Utils/APICalls";
import {
  Avatar,
  Button,
  ButtonGroup,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import styles from "./ClientList.module.scss";
import DataTableComponent from "../../components/DataTableComponent/DataTableComponent";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import ArrowDropDownOutlinedIcon from "@mui/icons-material/ArrowDropDownOutlined";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import ApprovedIcon from "../../assets/Images/icons/approvedIcon.svg";
import PendingIcon from "../../assets/Images/icons/pendingIcon.svg";
import searchIcon from "../../assets/Images/searchImage.svg";
import { Helmet } from "react-helmet";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import DownloadIcon from "@mui/icons-material/Download";
import SnackBar from "../../Components copy/SnackBars/SnackBar";
import SucessSnackBar from "../../components/SnackBar/SuccessSnackBar";

const titletextStyle = {
  fontSize: "13px",
  fontWeight: 600,
  color: "rgba(34, 34, 34, 1)",
  cursor: "pointer",
};
const divStyles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};
const contenttextStyle = { fontSize: "12px", fontWeight: 600 };
const options = [
  "All",
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const ITEM_HEIGHT = 48;

const years = [
  2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030, 2031, 2032,
];

export default function ClientList() {
  const [data, setData] = useState([]);
  const [approvedData, setApprovedData] = useState({});
  const [loading, setloading] = useState(false);
  const [tab, setTabs] = useState("Approved");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedMonth, setSelectedMonth] = useState("all");
  const [pageSize, setPageSize] = useState(20);
  const userDetails: any = sessionStorage.getItem("userDetails");
  const UserDetails: any = JSON.parse(userDetails);
  const [pageNo, setPageNo] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [clientsCount, setClientsCount] = useState(0);
  const [paginationCount, setpaginationCount] = useState(1);
  const [search, setsearch] = useState("");
  const [downloadMessage, setDownloadMessage] = useState("");
  const [downloadErrorMessage, setDownloadErrorMessage] = useState("");
  const [selectedyear, setselectedyear] = useState(new Date().getFullYear());
  const open = Boolean(anchorEl);
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = (selectedData: any) => {
    setAnchorEl(null);
    setSelectedMonth(selectedData);
  };
  const handleCloseMenuYear = (selectedData: any) => {
    setAnchorEl(null);
    setselectedyear(selectedData);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 41 }, (_, index) => 2020 + index);
  const pastyears = Array.from(
    { length: 3 },
    (_, index) => currentYear - (index + 1)
  );
  const sortYears = pastyears.sort((a: any, b: any) => a - b);

  const totalYears = [...years];

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (tab.toLowerCase() === "pending") {
        GetClientdetails();
      } else {
        GetApprovedClientDetails();
      }
    }, 300);

    return () => clearTimeout(delayDebounceFn);
  }, [pageNo, pageSize, selectedMonth, tab, search, selectedyear]);

  const GetApprovedClientDetails = () => {
    setloading(true);
    let obj: any = {
      page_no: pageNo,
      page_size: pageSize,
      filter_data: search,
    };
    getApprovedClientDetailsAPICall(obj)
      .then((response: any) => {
        // console.log("response", response.data.data);

        setData(
          response.data.data.client_data
            ? response.data.data.client_data
            : [
                {
                  client_name: "",
                  email: "",
                  client_code: "",
                  mobile: "No Records Found",
                  created_ts: "",
                  is_approved: "",
                },
              ]
        );
        setTotalRows(Math.ceil(response.data.data.total_records / 20));
        setClientsCount(response.data.data.total_records);

        setloading(false);
      })
      .catch((error: any) => {
        // console.log("error", error);
        setloading(false);
      });
  };

  const GetClientdetails = () => {
    setloading(true);
    let obj: any = {
      page_no: pageNo,
      page_size: pageSize,
      month: `${selectedMonth.toLowerCase()} ${selectedyear.toString()}`,
      approval_status: tab.toLowerCase(),
      filter_data: search,
    };

    getClientDetailsAPICall(obj)
      .then((response: any) => {
        // console.log("response", response.data.data);

        setData(
          response.data.data.client_data
            ? response.data.data.client_data
            : [
                {
                  client_name: "",
                  email: "",
                  client_code: "",
                  mobile: "No Records Found",
                  created_ts: "",
                  is_approved: "",
                },
              ]
        );
        setTotalRows(Math.ceil(response.data.data.total_records / 20));
        setClientsCount(response.data.data.total_records);

        setloading(false);
      })
      .catch((error: any) => {
        // console.log("error", error);
        setloading(false);
      });
  };

  const handleTabClick = (tabdata: any) => {
    setTabs(tabdata);
    setData([]);
    setsearch("");
    setPageNo(1);
    setpaginationCount(1);
  };

  function formatDate(inputDate: any) {
    const dateParts = inputDate && inputDate.split("-");
    // Rearrange the date parts to the desired format: dd-mm-yyyy
    const formattedDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
    return formattedDate;
  }

  const handleSearchChange = (e: any) => {
    setsearch(e.target.value);
  };

  const columns = [
    {
      name: (
        <b style={titletextStyle}>
          <div style={divStyles}>
            <PersonOutlineOutlinedIcon
              style={{ color: "rgba(34, 34, 34, 1)", marginRight: "5px" }}
            />{" "}
            <p>Name</p>
          </div>
        </b>
      ),
      selector: "client_name",
      // sortable: true,

      cell: (row: any) => (
        <div className={styles.nameWrapper}>
          <div className={styles.titleSection}>
            <p style={{ fontSize: "12px", fontWeight: 600 }}>
              {row.client_name}
            </p>
            <p style={{ fontSize: "10px", color: "rgba(174, 174, 174, 1)" }}>
              {row.email}
            </p>
          </div>
        </div>
      ),
    },
    {
      name: (
        <b style={titletextStyle}>
          {" "}
          <div style={divStyles}>
            <InsertDriveFileOutlinedIcon
              style={{ color: "rgba(34, 34, 34, 1)", marginRight: "5px" }}
            />{" "}
            <p>Client Code</p>
          </div>
        </b>
      ),
      selector: "client_code",
      // sortable: true,
      width: "180px",
      cell: (row: any) => <b style={contenttextStyle}>{row.client_code}</b>,
    },
    {
      name: (
        <b style={titletextStyle}>
          {" "}
          <div style={divStyles}>
            <CallOutlinedIcon
              style={{ color: "rgba(34, 34, 34, 1)", marginRight: "5px" }}
            />{" "}
            <p>Phone</p>
          </div>
        </b>
      ),
      selector: "mobile",
      // sortable: true,
      // width: "110px",
      cell: (row: any) => <b style={contenttextStyle}>{row.mobile}</b>,
    },

    {
      name: (
        <b style={titletextStyle}>
          <>
            <div style={divStyles}>
              <CalendarTodayOutlinedIcon
                style={{ color: "rgba(34, 34, 34, 1)", marginRight: "5px" }}
              />{" "}
              <p>Enrolment Date</p>
              {tab !== "Approved" && (
                <IconButton onClick={handleClick}>
                  {" "}
                  <ArrowDropDownOutlinedIcon
                    style={{
                      color: "rgba(34, 34, 34, 1)",
                      transform: open ? "rotate(180deg)" : "",
                      transition: "transform 0.4s ease",
                    }}
                  />
                </IconButton>
              )}
            </div>
            <Menu
              id="long-menu"
              MenuListProps={{
                "aria-labelledby": "long-button",
              }}
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              PaperProps={{
                sx: {
                  maxHeight: ITEM_HEIGHT * 4.5,
                  // width: "20ch",
                  "&::-webkit-scrollbar": {
                    width: "0px",
                  },
                  "&::-webkit-scrollbar-track": {
                    "-webkit-box-shadow": "inset 0 0 5px rgba(0, 103, 121, 1)",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "rgba(219, 245, 255, 0.5)",
                    borderRadius: "10px",
                  },
                },
              }}
            >
              <div style={{ display: "flex" }}>
                <div style={{ height: "100px" }}>
                  <p
                    style={{
                      fontSize: "12px",
                      fontWeight: 600,
                      textAlign: "center",
                      padding: "10px 0",
                    }}
                  >
                    Month
                  </p>
                  {options.map((option) => (
                    <>
                      <MenuItem
                        key={option}
                        selected={
                          option.toLowerCase() ===
                          selectedMonth.toLocaleLowerCase()
                        }
                        onClick={() => {
                          handleCloseMenu(option);
                        }}
                      >
                        {option}
                      </MenuItem>
                    </>
                  ))}
                </div>
                <div style={{ height: "500px" }} className={styles.menuwrapper}>
                  <p
                    style={{
                      fontSize: "12px",
                      fontWeight: 600,
                      textAlign: "center",
                      padding: "10px 0",
                    }}
                  >
                    Year
                  </p>
                  {totalYears.map((option) => (
                    <MenuItem
                      key={option}
                      selected={option === selectedyear}
                      onClick={() => {
                        handleCloseMenuYear(option);
                      }}
                    >
                      {option}
                    </MenuItem>
                  ))}
                </div>
              </div>
            </Menu>
          </>
        </b>
      ),
      selector: "source_id",
      // sortable: true,
      cell: (row: any) => (
        <b style={contenttextStyle}>
          {row.created_ts === ""
            ? ""
            : row.created_ts && formatDate(row.created_ts.slice(0, 10))}
        </b>
      ),
      // width: "200px",
    },
    // {
    //   name: (
    //     <b style={titletextStyle}>
    //       {" "}
    //       <div style={divStyles}>
    //         <ChatBubbleOutlineOutlinedIcon
    //           style={{ color: "rgba(34, 34, 34, 1)", marginRight: "5px" }}
    //         />{" "}
    //         <p>Status</p>
    //       </div>
    //     </b>
    //   ),
    //   selector: "mobile",
    //   // sortable: true,
    //   // width: "200px",
    //   cell: (row: any) => (
    //     <b style={contenttextStyle}>
    //       <div
    //         style={{
    //           display: "flex",
    //           alignItems: "center",
    //           justifyContent: "space-between",
    //           width: "130px",
    //         }}
    //       >
    //         {row.is_approved !== "" && (
    //           <>
    //             <p>{row.is_approved ? "Approved" : "Pending"}</p>
    //             <img src={row.is_approved ? ApprovedIcon : PendingIcon} />
    //           </>
    //         )}
    //       </div>
    //     </b>
    //   ),
    // },
  ];
  const Approvedcolumns = [
    {
      name: (
        <b style={titletextStyle}>
          <div style={divStyles}>
            <PersonOutlineOutlinedIcon
              style={{ color: "rgba(34, 34, 34, 1)", marginRight: "5px" }}
            />{" "}
            <p>Name</p>
          </div>
        </b>
      ),
      selector: "full_name",
      // sortable: true,

      cell: (row: any) => (
        <div className={styles.nameWrapper}>
          <div className={styles.titleSection}>
            <p style={{ fontSize: "12px", fontWeight: 600 }}>{row.full_name}</p>
            <p style={{ fontSize: "10px", color: "rgba(174, 174, 174, 1)" }}>
              {row.email}
            </p>
          </div>
        </div>
      ),
    },
    {
      name: (
        <b style={titletextStyle}>
          {" "}
          <div style={divStyles}>
            <InsertDriveFileOutlinedIcon
              style={{ color: "rgba(34, 34, 34, 1)", marginRight: "5px" }}
            />{" "}
            <p>Client Code</p>
          </div>
        </b>
      ),
      selector: "userid",
      // sortable: true,
      width: "180px",
      cell: (row: any) => <b style={contenttextStyle}>{row.userid}</b>,
    },
    {
      name: (
        <b style={titletextStyle}>
          {" "}
          <div style={divStyles}>
            <CallOutlinedIcon
              style={{ color: "rgba(34, 34, 34, 1)", marginRight: "5px" }}
            />{" "}
            <p>Phone</p>
          </div>
        </b>
      ),
      selector: "mobile_no",
      // sortable: true,
      // width: "110px",
      cell: (row: any) => <b style={contenttextStyle}>{row.mobile_no}</b>,
    },

    {
      name: (
        <b style={titletextStyle}>
          <>
            <div style={divStyles}>
              <CalendarTodayOutlinedIcon
                style={{ color: "rgba(34, 34, 34, 1)", marginRight: "5px" }}
              />{" "}
              <p>Enrolment Date</p>
              {tab !== "Approved" && (
                <IconButton onClick={handleClick}>
                  {" "}
                  <ArrowDropDownOutlinedIcon
                    style={{
                      color: "rgba(34, 34, 34, 1)",
                      transform: open ? "rotate(180deg)" : "",
                      transition: "transform 0.4s ease",
                    }}
                  />
                </IconButton>
              )}
            </div>
            <Menu
              id="long-menu"
              MenuListProps={{
                "aria-labelledby": "long-button",
              }}
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              PaperProps={{
                sx: {
                  maxHeight: ITEM_HEIGHT * 4.5,
                  width: "20ch",
                  "&::-webkit-scrollbar": {
                    width: "5px",
                  },
                  "&::-webkit-scrollbar-track": {
                    "-webkit-box-shadow": "inset 0 0 5px rgba(0, 103, 121, 1)",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "rgba(219, 245, 255, 0.5)",
                    borderRadius: "10px",
                  },
                },
              }}
            >
              {options.map((option) => (
                <MenuItem
                  key={option}
                  selected={
                    option.toLowerCase() === selectedMonth.toLocaleLowerCase()
                  }
                  onClick={() => {
                    handleCloseMenu(option);
                  }}
                >
                  {option}
                </MenuItem>
              ))}
            </Menu>
          </>
        </b>
      ),
      selector: "source_id",
      // sortable: true,
      cell: (row: any) => (
        <b style={contenttextStyle}>
          {row.account_open_date === "" ? "" : row.account_open_date}
        </b>
      ),
      // width: "200px",
    },
    // {
    //   name: (
    //     <b style={titletextStyle}>
    //       {" "}
    //       <div style={divStyles}>
    //         <ChatBubbleOutlineOutlinedIcon
    //           style={{ color: "rgba(34, 34, 34, 1)", marginRight: "5px" }}
    //         />{" "}
    //         <p>Status</p>
    //       </div>
    //     </b>
    //   ),
    //   selector: "mobile",
    //   // sortable: true,
    //   // width: "200px",
    //   cell: (row: any) => (
    //     <b style={contenttextStyle}>
    //       <div
    //         style={{
    //           display: "flex",
    //           alignItems: "center",
    //           justifyContent: "space-between",
    //           width: "130px",
    //         }}
    //       >
    //         {row.is_approved !== "" && (
    //           <>
    //             <p>Approved</p>
    //             <img src={ApprovedIcon} />
    //           </>
    //         )}
    //       </div>
    //     </b>
    //   ),
    // },
  ];
  const handlePageChange = (value: any, pagenumber: any) => {
    setPageNo(pagenumber);
    setpaginationCount(pagenumber);
  };

  const handleDownloadClients = () => {
    if (tab === "Approved") {
      DownloadApprovedClientsAPICall()
        .then((response: any) => {
          downloadCsv(response.data);
          setDownloadMessage("Pending clients records Download successfully");
          setTimeout(() => {
            setDownloadMessage("");
          }, 5000);
        })
        .catch((error: any) => {
          if (error.response.data.error.message) {
            setDownloadErrorMessage(error.response.data.error.message);
          } else {
            setDownloadErrorMessage("Error downloading");
          }
          setTimeout(() => {
            setDownloadErrorMessage("");
          }, 5000);
        });
    } else {
      DownloadPendingClientsAPICall()
        .then((response: any) => {
          downloadCsv(response.data);
          setDownloadMessage("Pending clients records Download successfully");
          setTimeout(() => {
            setDownloadMessage("");
          }, 5000);
        })
        .catch((error: any) => {
          if (error.response.data.error.message) {
            setDownloadErrorMessage(error.response.data.error.message);
          } else {
            setDownloadErrorMessage("Error downloading");
          }
          setTimeout(() => {
            setDownloadErrorMessage("");
          }, 5000);
        });
    }
  };

  const downloadCsv = (csvContent) => {
    const blob = new Blob([csvContent], { type: "csv" });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${tab} Client Details.csv`);
    document.body.appendChild(link);

    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  return (
    <>
      <Helmet>
        <title>Clients</title>
        <meta name="Clients" content="Clients" />
      </Helmet>
      <SnackBar message={downloadErrorMessage} />
      <SucessSnackBar message={downloadMessage} />
      <div className={styles.mainWrapper}>
        <div className={styles.topWrapper}>
          <div className={styles.topWrapperLeftContainer}>
            {/* <p className={styles.welcomeText}>
            Welcome {UserDetails ? UserDetails.Name : ""}
          </p> */}
            <p className={styles.clientText}>Client List ({clientsCount})</p>
          </div>
          <div className={styles.topWrapperRightContainer}>
            <div className={styles.searchbarContainer}>
              <div className={styles.searchbar}>
                <div className={styles.searchbarWrapper}>
                  <img src={searchIcon} alt="" className={styles.searchIcon} />
                  <input
                    className={styles.searchText}
                    placeholder="Search Clients"
                    value={search}
                    onChange={handleSearchChange}
                    autoFocus
                  />
                </div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                alignContent: "center",
                gap: "20px",
              }}
            >
              <ButtonGroup
                variant="outlined"
                aria-label="outlined button group"
              >
                {/* <Button
              sx={{
                background: tab === "All" ? "rgba(0, 103, 121, 1)" : "",
                fontSize: "14px",
                textTransform: "none",
                color: tab === "All" ? "white" : "rgba(52, 64, 84, 1)",

                "&:hover": {
                  background: tab === "All" ? "rgba(0, 103, 121, 1)" : "",
                  color: tab === "All" ? "white" : "rgba(52, 64, 84, 1)",
                },
              }}
              onClick={() => {
                handleTabClick("All");
              }}
            >
              All
            </Button> */}
                <Button
                  sx={{
                    background:
                      tab === "Approved" ? "rgba(0, 103, 121, 1)" : "",
                    fontSize: "14px",
                    textTransform: "none",
                    color: tab === "Approved" ? "white" : "rgba(52, 64, 84, 1)",
                    "&:hover": {
                      background:
                        tab === "Approved" ? "rgba(0, 103, 121, 1)" : "",
                      color:
                        tab === "Approved" ? "white" : "rgba(52, 64, 84, 1)",
                    },
                  }}
                  onClick={() => {
                    handleTabClick("Approved");
                  }}
                >
                  Approved
                </Button>
                <Button
                  sx={{
                    background: tab === "Pending" ? "rgba(0, 103, 121, 1)" : "",
                    fontSize: "14px",
                    textTransform: "none",
                    color: tab === "Pending" ? "white" : "rgba(52, 64, 84, 1)",
                    "&:hover": {
                      background:
                        tab === "Pending" ? "rgba(0, 103, 121, 1)" : "",
                      color:
                        tab === "Pending" ? "white" : "rgba(52, 64, 84, 1)",
                    },
                  }}
                  onClick={() => {
                    handleTabClick("Pending");
                  }}
                >
                  Pending
                </Button>
              </ButtonGroup>
              <div>
                <Button
                  variant="contained"
                  sx={{
                    textTransform: "none",
                    fontSize: "13px",
                    "&:hover": {
                      background: "rgba(0, 103, 121, 1)",
                    },
                  }}
                  startIcon={<DownloadIcon />}
                  onClick={handleDownloadClients}
                >
                  Download reports
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div
          className={styles.tableWrapper}
          style={{ border: loading ? " " : "1px solid rgba(213, 233, 236, 1)" }}
        >
          <DataTableComponent
            data={data}
            columns={tab === "Approved" ? Approvedcolumns : columns}
            loading={loading}
            totalRows={totalRows}
            handlePageChange={handlePageChange}
            paginationCount={paginationCount}
          />
        </div>
      </div>
    </>
  );
}
